class FontOptions extends HTMLElement {
  connectedCallback() {
    this.innerHTML = /* html */ `
        <p class="my-3"><strong data-i18n="components.fontOptions.title">Lettertype</strong></p>
        <div class="d-flex">
            <div
            class="js-font-option style-option font modern px-3 py-1 mr-1"
            data-font="modern"
            >
            <span data-i18n="components.fontOptions.modern">Modern</span>
            </div>
            <div
            class="js-font-option style-option font classic px-3 py-1"
            data-font="classic"
            >
            <span data-i18n="components.fontOptions.classic">Klassiek</span>
            </div>
            <div
            class="js-font-option style-option font mono px-3 py-1"
            data-font="mono"
            >
            <span data-i18n="components.fontOptions.mono">Mono</span>
            </div>
        </div>
    `;
  }
}

customElements.define("font-options", FontOptions);
